import React, { useEffect } from "react";
import "./App.css";
import NavigationMenu from "./components/navigationMenu";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
const App = () => {
  useEffect(() => {
    const textElements = document.querySelectorAll(".text-animate");
    const sectionElements = document.querySelectorAll(".section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible", "show");
          }
        });
      },
      { threshold: 0.3 }
    );

    textElements.forEach((el) => observer.observe(el));
    sectionElements.forEach((el) => observer.observe(el));

    return () => {
      textElements.forEach((el) => observer.unobserve(el));
      sectionElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="App">
      <NavigationMenu />
      <div className="min-h-screen bg-gray-900 text-white">
        <div
          className="bg-cover bg-center h-screen flex flex-col justify-center items-center"
          style={{
            backgroundImage: `url('${process.env.REACT_APP_PUBLIC_URL}/assets/imgs/1.jpg')`,
            filter: 'grayscale(100%)',
            maxHeight: '100%',
            maxWidth: '100%',
            backgroundSize: 'cover',
          }}
          id="home"
        >
          <h1 id="hero-text" className="mx-2 text-5xl font-bold mb-4 text-center">
            PRISIJUNK IR TOBULINK MOTOKROSO ĮGŪDŽIUS
          </h1>
          <button
            onClick={() => {
              document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
            }}
            className="joinButton"
          >
            Prisijunk dabar
          </button>
        </div>
        <section className="d-flex justify-content-center" id="about">
          <div className="d-flex justify-content-center" id="aboutContent">
            <div className="col-md-4 text-animate align-self-center">
              <img src={`${process.env.REACT_APP_PUBLIC_URL}/assets/imgs/profile.jpg`} alt="Profile" className="img-fluid rounded-lg shadow-lg profile-img" />
            </div>
            <div className="col-md-8 text-animate">
              <h2 className="text-3xl font-bold mb-4">KAS TAVE TRENIRUOS?</h2>
              <p className="mb-6 profile-text">
                Aš - Nojus Gasiūnas. Esu daugkartinis Lietuvos motokroso čempionas ir prizininkas, taip pat Baltijos šalių čempionatų prizininkas. Motokrosą profesionaliai sportavau 17 metų, o šiandien savo patirtį perduodu naujai sportininkų kartai. Treniruoju tiek pradedančiuosius, tiek aukščiausio lygio atletus bei vaikus.
                <br />
                Mano auklėtiniai 2024 m. tapo Lietuvos čempionais ir prizininkais, kartu su vaikais dalyvavome  Latvijos, Europos bei Pasaulio čempionatuose. Taip pat turėjau garbę dirbti treneriu vaikų pasaulio čempionate.
                <br />
                Trenerio darbas man – ne tik profesija, bet ir gyvenimo būdas. Atiduodu visą save ir to paties tikiuosi iš kiekvieno sportininko, su kuriuo dirbu. Jei sieki aukščiausių rezultatų – kartu pasieksime tikslus!              </p>
            </div>
          </div>
        </section>
        <section id="services" className="section py-16 px-6 bg-gray-900">
          <h2 className="text-3xl font-bold text-center mb-8 text-animate">
            KO IŠMOKSI PAS MUS?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {["Pradedantiesiems", "Pažengusiems", "Profesionalams"].map((title, index) => (
              <div key={index} className="bg-gray-800 p-6 rounded-lg text-center text-animate">
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p>
                  {index === 0
                    ? "Išmoksi motokroso pagrindų - saugiai ir taisyklingai važiuoti motociklu."
                    : index === 1
                      ? "Įgysi patirties išmokdamas atlikti sudėtingus šuolius ir posūkius."
                      : "Darbas su profesionaliais treneriais ruošiantis aukščiausio lygio varžyboms."}
                </p>
              </div>
            ))}
          </div>
        </section>
        <section id="gallery" className="section py-16 px-6 bg-gray-800 text-center">
          <h2 className="text-3xl font-bold mb-8 text-animate visible">GALERIJA</h2>
          <div className="carousel-container mx-auto">
            <Carousel showThumbs={false} infiniteLoop useKeyboardArrows showArrows autoPlay style={{ minHeight: '100%'}} >
              {["motocross,bike", "dirtbike", "offroad", "random"].map((query, index) => (
                <div className="carousel-image-container" key={index}>
                  <img
                    src={`./assets/imgs/${index}.jpg`}
                    alt={`Motocross ${index + 1}`}
                    className="carousel-image rounded-lg"
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </section>
        <section id="contact" className="section py-16 px-6 bg-gray-900 text-center">
          <h2 className="text-3xl font-bold mb-4 text-animate">KONTAKTAI</h2>
          <p className="mb-6 text-animate">
            Susidomėjai? Turi klausimų? Susisiek! <br />
            El. paštas: <br />
            <a href="mailto:
            ng77@gmail.com
            ">nojus.gasiunas@gmail.com</a>
            <br />
            Telefono numeris: <br />
            <span className="mr-4">
              +37067051523
            </span>
            <br />
            Socialiniai tinklai:
            <div className="flex justify-center space-x-4 text-animate social-icons">
              <a href="https://www.facebook.com/nojus.gasiunas.3" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} size="2x" color="white" />
              </a>
              <a href="https://www.instagram.com/nojusgasiunas/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} size="2x" color="white" />
              </a>
            </div>
          </p>
        </section>
        <footer className="py-6 bg-gray-800 text-center">
          <p>© 2025 MOTOKLUBAS NG77</p>
        </footer>
      </div>
    </div>
  );
};

export default App;